const name = {
  NEW_REGISTER: 'Novo Cadastro',
  REGISTER: 'Cadastro',
  STEPS: 'Passos',
  ERROR: 'Erro',
  EMBED: 'Embed'
};

export default name;
